'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface Row {
	title: string
	text: string
	imageDesktop: string
	imageTablet: string
	imageMobile: string
}

// ЗАГЛУШКИ: пути к картинкам (по 3 варианта на строку) и тексты — заменить на свои
const rows: Row[] = [
	{
		title: 'Моментальные платежи',
		text: 'Оплата по ссылке — всё заполняется автоматически. Клиенту остаётся только подтвердить перевод. Деньги моментально поступают на ваш счёт.',
		imageDesktop: '/images/b2b/b2bsolution_row1_desktop.png',
		imageTablet: '/images/b2b/b2bsolution_row1_tablet.png',
		imageMobile: '/images/b2b/b2bsolution_row1_mobile.png'
	},
	{
		title: 'Удобная оплата по счёту из 1С',
		text: 'Можно загружать счёт, сформированный в 1С, и автоматически получать QR-код для оплаты через СБП.',
		imageDesktop: '/images/b2b/b2bsolution_row2_desktop.png',
		imageTablet: '/images/b2b/b2bsolution_row2_tablet.png',
		imageMobile: '/images/b2b/b2bsolution_row2_mobile.png'
	},
	{
		title: 'Оплата по QR через СБП',
		text: 'Создайте QR для мгновенной оплаты через СБП. Клиент сможет производить оплату более чем от 200 банков РФ. Платёж быстро поступит на ваш счёт в течение 1‑2 минут.',
		imageDesktop: '/images/b2b/b2bsolution_row3_desktop.png',
		imageTablet: '/images/b2b/b2bsolution_row3_tablet.png',
		imageMobile: '/images/b2b/b2bsolution_row3_mobile.png'
	}
]

const B2bSolution: React.FC = () => {
	return (
		<section className={styles.b2bSolution}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.subtitle}>Решение True.pay B2B</div>
				<h2
					className={styles.title}
					dangerouslySetInnerHTML={{ __html: '<span>Три сценария оплаты</span> в одном платёжном виджете' }}
				/>
			</AnimatedSection>
			<div className={styles.sections}>
				{rows.map((row, index) => (
					<AnimatedSection key={index} animation='slideUp' className={styles.row}>
						<div className={styles.rowText}>
							<h3 className={styles.sectionTitle}>{row.title}</h3>
							<p className={styles.text} dangerouslySetInnerHTML={{ __html: row.text }} />
						</div>
						<div className={styles.rowImage}>
							<Image
								src={row.imageDesktop}
								alt={row.title}
								width={635}
								height={440}
								className={styles.desktopImage}
								unoptimized
							/>
							<Image
								src={row.imageTablet}
								alt={row.title}
								width={680}
								height={440}
								className={styles.tabletImage}
								unoptimized
							/>
							<Image
								src={row.imageMobile}
								alt={row.title}
								width={328}
								height={212}
								className={styles.mobileImage}
								unoptimized
							/>
						</div>
					</AnimatedSection>
				))}
			</div>
		</section>
	)
}

B2bSolution.displayName = 'B2bSolution'

export default B2bSolution
